export type FolderSelectItem = {
  id: string;
  name: string;
  color: string;
};

type FolderSelectListProps = {
  folders: FolderSelectItem[];
  selectedFolderId: string | null;
  noneLabel: string;
  onSelect: (folderId: string | null) => void;
  onDelete?: (folderId: string) => void;
};

export default function FolderSelectList({
  folders,
  selectedFolderId,
  noneLabel,
  onSelect,
  onDelete,
}: FolderSelectListProps) {
  return (
    <>
      <button
        onClick={() => onSelect(null)}
        className={`w-full flex items-center gap-3 px-4 py-3.5 rounded-xl mb-2 transition-all cursor-pointer ${
          selectedFolderId === null
            ? "bg-indigo-50 border-2 border-indigo-300"
            : "bg-gray-50 border-2 border-transparent hover:bg-gray-100"
        }`}
      >
        <div className="w-8 h-8 bg-gray-200 rounded-lg flex items-center justify-center">
          <i className="ri-inbox-line text-gray-500"></i>
        </div>
        <span
          className={`text-sm font-medium ${
            selectedFolderId === null ? "text-indigo-700" : "text-gray-700"
          }`}
        >
          {noneLabel}
        </span>
        {selectedFolderId === null && (
          <i className="ri-check-line text-indigo-500 ml-auto"></i>
        )}
      </button>

      <div className="space-y-2">
        {folders.map((folder) => (
          <div
            key={folder.id}
            className={`group flex items-center gap-3 px-4 py-3.5 rounded-xl transition-all cursor-pointer ${
              selectedFolderId === folder.id
                ? "bg-indigo-50 border-2 border-indigo-300"
                : "bg-gray-50 border-2 border-transparent hover:bg-gray-100"
            }`}
            onClick={() => onSelect(folder.id)}
          >
            <div
              className="w-8 h-8 rounded-lg flex items-center justify-center"
              style={{ backgroundColor: folder.color + "20" }}
            >
              <i
                className="ri-folder-fill text-lg"
                style={{ color: folder.color }}
              ></i>
            </div>
            <span
              className={`text-sm font-medium flex-1 ${
                selectedFolderId === folder.id
                  ? "text-indigo-700"
                  : "text-gray-700"
              }`}
            >
              {folder.name}
            </span>
            {selectedFolderId === folder.id && (
              <i className="ri-check-line text-indigo-500"></i>
            )}
            {onDelete && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(folder.id);
                }}
                className="opacity-0 group-hover:opacity-100 w-7 h-7 flex items-center justify-center text-gray-400 hover:text-red-500 rounded-lg hover:bg-red-50 transition-all cursor-pointer"
                aria-label="삭제"
              >
                <i className="ri-close-line text-sm"></i>
              </button>
            )}
          </div>
        ))}
      </div>
    </>
  );
}
